import BasePropertyView from 'BasePropertyView.js';
import fileAttachmentTemplate from 'properties/main/fileattachment-button-labels.ejs';
import webSignatureTemplate   from 'properties/main/websignature-button-labels.ejs'
import undoService from 'UndoService';
import constants from 'Constants';
import mobileSyncService from "../../../service/mobile/MobileSyncService";
import util             from 'util/Util.js';
class MainButtonLabelsView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        if (this.model.get('factoryKey') === 'control_websignature') {
            this.template = webSignatureTemplate;
        }

        if (this.model.get('factoryKey') === 'control_file_attachment') {
            this.template = fileAttachmentTemplate;
        }

        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        let oldVal = this.model.get(propName);

        mobileSyncService.synchronizeMobileForm(this.model, this.model.get('factoryKey'), {key: propName, val: propVal });

        if (propVal.toString() !== oldVal.toString()) {

            this.model.set( propName, propVal);
            undoService.add({
                undo: () => {
                    this.model.set(propName, oldVal);
                    this.render();
                },
                redo:() => {
                    this.model.set(propName, propVal);
                    this.render();            
                }
            }, constants.UNDO_PROP_CHANGE);
        }
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }

        this.delegateEvents();
        return this;
    }

}

export default MainButtonLabelsView;
